import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';

import { Location, LocationDataStore, locationSelectors } from '@skinsoft/entity/'

export class LocationOfflineDataFetcher extends OfflineDataFetcher<Location>{
    constructor(cacheKey: string) {
        super(cacheKey);
    }

    /**
     * Returns true if the name or the path of the location contains the queryText
     * @param entity 
     * @param queryText 
     * @param locale 
     */
    protected async queryTextFilter(entity: Location, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        let titleMatches = false;
        let pathMatches = false;

        // Testing title
        const title: string = locationSelectors.title(entity, locale).toLowerCase() || "";
        if (title) {
            titleMatches = title.includes(lowerCaseQueryText)
        }

        // Testing path
        const path: string = locationSelectors.pathIds(entity)
        const resolvedPath = await (await LocationDataStore.getInstance().resolvePath(path, locale))?.toLowerCase()
        if (resolvedPath) {
            pathMatches = resolvedPath.includes(lowerCaseQueryText)
        }

        return titleMatches || pathMatches;
    }
}